import { AppConfig } from "@app/config";
import { getAuthToken } from "@shared/api/Auth.ts";
import { problemDetailsMiddleware } from "@shared/api/ProblemDetailsMiddleware.ts";

import {
	AnalyticsApi,
	AuthApi,
	Bank131Api,
	Configuration,
	CrossPlayApi,
	DataConnectionsApi,
	FbinstantApi,
	FriendsApi,
	FtlIntegrationApi,
	GamesApi,
	GoApi,
	InfoApi,
	InviteApi,
	ManifestApi,
	NativeApi,
	PlayApi,
	ProfileApi,
	PublicGameConfigApi,
	PushTokensApi,
	StoreApi,
	SupportApi,
	WizqApi,
	YandexgamesApi} from "./gen";

export const openApiConfig: Configuration = new Configuration({
	basePath: AppConfig.apiBasePath,
	accessToken: getApiAccessToken,
	middleware: [problemDetailsMiddleware]
});

function getApiAccessToken() {
	const token = getAuthToken();
	return token ?? "";
}

const OpenApiClient = {
	Invite: new InviteApi(openApiConfig),
	Analytics: new AnalyticsApi(openApiConfig),
	DataConnections: new DataConnectionsApi(openApiConfig),
	Manifest: new ManifestApi(openApiConfig),
	Native: new NativeApi(openApiConfig),
	Auth: new AuthApi(openApiConfig),
	Games: new GamesApi(openApiConfig),
	Play: new PlayApi(openApiConfig),
	Profile: new ProfileApi(openApiConfig),
	Store: new StoreApi(openApiConfig),
	Info: new InfoApi(openApiConfig),
	YandexGames: new YandexgamesApi(openApiConfig),
	FacebookInstantGames: new FbinstantApi(openApiConfig),
	PublicGameConfigApi: new PublicGameConfigApi(openApiConfig),
	Friends: new FriendsApi(openApiConfig),
	Go: new GoApi(openApiConfig),
	Bank131: new Bank131Api(openApiConfig),
	WizQ: new WizqApi(openApiConfig),
	FtlIntegration: new FtlIntegrationApi(openApiConfig),
	Support: new SupportApi(openApiConfig),
	PushToken: new PushTokensApi(openApiConfig),
	CrossPlay: new CrossPlayApi(openApiConfig),
};

export default OpenApiClient;
